import {DocumentNode, gql} from "@apollo/client";

export const UPDATE_NOTIFICATION_SETTING_MUTATION: DocumentNode = gql(`
    mutation UpdateNotificationSettings($dto: UpdateNotificationSettingRequest!) {
        updateNotificationSettings(updateNotificationSettingDTO: $dto) {
            ...NotificationSetting
        }
    }
`);
